import { render } from "./BtnProfile.vue?vue&type=template&id=45b74d7c"
import script from "./BtnProfile.vue?vue&type=script&lang=js"
export * from "./BtnProfile.vue?vue&type=script&lang=js"

import "./BtnProfile.vue?vue&type=style&index=0&id=45b74d7c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__